module.exports = __webpack_public_path__ + "media/images/error-icon-d0603e85.svg";